export const MyAccountResourcesEN: MyAccountResourcesInterface = {
  title: "My Account",
  nextButton: "Forward",
  backButton: "Back",
  signatureTitle: "Signature",
  errorMissingInput: "Please fill in all fields",
  phoneNumber: {
    label: "Phone Number",
    placeholder: "Please enter phone number",
  },
  errors: {
    registerPic: "The picture you are uploading is too large.",
  },
  profilePicture: {
    label: "Profile Picture",
    name: "profilePicture",
    error: "Please select your profile picture",
    validation: "Wrong profile picture",
    description: () => (
      <>
        <h4>Drop files here or click to upload.</h4>
        <span className="text-muted font-13">Only images, max 6MB</span>
      </>
    ),
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  errorPasswordMatch: "Passwords do not match.",
  password: {
    label: "Password",
    placeholder: "Please enter password",
  },
  passwordRepeat: {
    label: "Repeat password",
    placeholder: "Please repeat password",
  },
};

interface IErrors {
  registerPic: string;
}

export interface MyAccountResourcesInterface {
  title: string;
  nextButton: string;
  backButton: string;
  signatureTitle: string;
  errorMissingInput: string;
  phoneNumber: {
    label: string;
    placeholder: string;
  };
  profilePicture: {
    label: string;
    name: string;
    error: string;
    validation: string;
    description: () => JSX.Element;
  };
  errorPasswordMatch: string;
  password: {
    label: string;
    placeholder: string;
  };
  passwordRepeat: {
    label: string;
    placeholder: string;
  };
  successModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  errors: IErrors;
}
